import React, { useLayoutEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CaretRightOutlined, PlusOutlined } from "@ant-design/icons";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Button, Form, Input, DatePicker, Collapse, Row, Col, Select, Table, Spin, notification } from "antd";
import moment from "moment";
import "../../screens/Product/product.css";
import "../Style/style.css";
import { useHistory } from "react-router-dom";
import { ReadCookie } from "../../utils/readCookie";
import { getSaleOrderFormData } from "../../redux/actions/salesOrder.action";
import { useCallback, useEffect } from "react";
import { getOrderStatus } from "../../redux/actions/orderStatus.action";
import { getFactor } from "../../redux/actions/factor.action";
import { createActualDamageReceiptEmail, createCreditNoteEmail, createDamageReceiptEmail, getActualDamageReceiptEmail, getCreditNoteEmail, getDamageReceiptEmail, } from "../../redux/actions/invoiceEmail.action";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getCustomerType } from "../../redux/actions/customerType.action";

const ActualDamageReceiptEmail = ({ token }) => {
    TabTitle("Actual Damage Receipt Email")
    const [form] = Form.useForm();
    const history = useHistory();
    const dispatch = useDispatch();
    const { saleOrderFormData, paymentterm, customerTypes } = useSelector((state) => state);
    const { Panel } = Collapse;
    const companyId = ReadCookie("defaultCompany");
    const menuId = ReadCookie("menuId");
    const [lines, setLines] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [excelData, setExcelData] = useState([])
    const [emailSending, setEmailSending] = useState(false);
    const { Option } = Select;

    useEffect(() => {
        dispatch(getOrderStatus(token));
        dispatch(getFactor(token, menuId));
        dispatch(getPaymentTerm(token));
        dispatch(getCustomerType(token));
    }, [dispatch, token]);


    const onFinish = async (e) => {
        await form.validateFields().then((values) => {
            setLoading(true);
            dispatch(getActualDamageReceiptEmail(token, values)).then((res) => {
                if (res?.type === "GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS") {
                    setLoading(false);
                    downloadExcelFileData(res?.payload?.data);
                    setLines(res?.payload?.data);
                }
            }).catch((error) => {
                setLoading(false);
            })
        })
    }

    function downloadExcelFileData(data) {
        setExcelData(
            data.map((v) => {
                return {
                    "Damage Receipt #": v["damage_header_no"],
                    "Date": v["damage_date"],
                    "CM #": v["memo_header_no"],
                    "RA No": v["return_header_no"],
                    "RA Approval No": v["ra_no"],
                    "Customer Name": v["customer_name"],
                    "Email": v["email"],
                    "Term": v["term"],
                    "Qty": v["quantity"],
                    "Amount": `$${v["net_amount"]}`,
                    "Email Send": v["emailsent"],
                };
            })
        )
    }

    const columns = [
        {
            title: "Damage Receipt #",
            dataIndex: "damage_header_no",
            // width: 140,
            fixed: 'left',
        },
        {
            title: "Date",
            dataIndex: "damage_date",
            // width: 80,
        },
        {
            title: "CM #",
            dataIndex: "memo_header_no",
            // width: 80,
            fixed: 'left',
        },
        {
            title: "RA No",
            dataIndex: "return_header_no",
            // width: 80,
            fixed: 'left',
        },
        {
            title: "RA Approval No",
            dataIndex: "ra_no",
            // width: 80,
            fixed: 'left',
        },
        {
            title: "Customer Name",
            dataIndex: "customer_name",
            // width: 160,
        },
        {
            title: "Email",
            dataIndex: "email",
            // width: 160,
        },
        {
            title: "Term",
            dataIndex: "term",
            // width: 140,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            // width: 100,
            align: "right"
        },
        {
            title: "Amount",
            dataIndex: "net_amount",
            // width: 100,
            align: "right",
            render: (text, record) => {
                return <>$ {numeral(record.net_amount).format("0,0.00")}</>;
            }
        },
        {
            title: "Email",
            dataIndex: "emailsent",
            // width: 140,
        },
    ]


    function debounce(cb, delay = 1000) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                cb(...args);
            }, delay);
        };
    }


    const handleChanges = (val) => {
        dispatch(getSaleOrderFormData(token, companyId, menuId, val, "")).then(
            (res) => {
                if (
                    res.type === "GET_GENDER_HEADER_DATA_SUCCESS" &&
                    res?.payload.length === 0
                ) {
                    notification("warning", "Empty List");
                }
                if (res?.payload?.customerDetail?.length === 0) {
                }
            }
        );
    };

    const optimizedFn = useCallback(debounce(handleChanges), []);


    let result =
        selectedRows.length > 0 &&
        selectedRows?.reduce(function (r, a) {
            r[a.email] = r[a.email] || [];
            r[a.email].push(a);
            return r;
        }, Object.create(null));

    const selectedRow = result ? Object.values(result) : [];



    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRows(selectedRows);
        },
        // getCheckboxProps: (record) => ({
        //     disabled: record.memo_header_no === null, // 👈 null ho toh disable
        // }),
    };

    console.log("selectedRow", selectedRow)


    // const sendEmail = () => {
    //     setEmailSending(true);

    //     Promise.all(
    //         selectedRow.map((resp) =>
    //             dispatch(createActualDamageReceiptEmail(token, resp))
    //         )
    //     ).then(async (results) => {
    //         let allSuccess = true;

    //         results.forEach((res) => {
    //             if (res?.type === "CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS") {
    //                 notification.success({
    //                     message: "Success",
    //                     description: res?.payload?.msg || "The email has been sent.",
    //                     placement: "topRight",
    //                     duration: 3,
    //                 });
    //             } else {
    //                 allSuccess = false;
    //                 notification.error({
    //                     message: "Error",
    //                     description: "Failed to send one or more emails.",
    //                 });
    //             }
    //         });

    //         setLoading(true);
    //         try {
    //             const values = form.getFieldsValue();
    //             const res = await dispatch(getActualDamageReceiptEmail(token, values));
    //             if (res?.type === "GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS") {
    //                 downloadExcelFileData(res?.payload?.data);
    //                 setLines(res?.payload?.data);
    //                 setSelectedRows([])
    //             }
    //         } catch (error) {
    //             notification.error({
    //                 message: "Error",
    //                 description: "Failed to refresh data.",
    //             });
    //         } finally {
    //             setLoading(false);
    //         }

    //     }).finally(() => {
    //         setEmailSending(false);
    //     });
    // };

    const sendEmail = () => {
        setEmailSending(true);
        Promise.all(
            selectedRow.map((group) => {
                const firstRecord = group[0]; // group ka first record
                if (firstRecord.memo_header_no === null) {
                    return dispatch(createActualDamageReceiptEmail(token, group));
                } else {
                    return dispatch(createDamageReceiptEmail(token, group));
                }

            })
        ).then(async (results) => {

            results.forEach((res) => {
                if (
                    res?.type === "CREATE_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS" ||
                    res?.type === "CREATE_DAMAGE_RECEIPT_EMAIL_SUCCESS"
                ) {
                    notification.success({
                        message: "Success",
                        description: res?.payload?.msg || "The email has been sent.",
                        placement: "topRight",
                        duration: 3,
                    });
                } else {
                    notification.error({
                        message: "Error",
                        description: "Failed to send one or more emails.",
                    });
                }
            });

            setLoading(true);

            try {
                const values = form.getFieldsValue();
                const res = await dispatch(getActualDamageReceiptEmail(token, values));

                if (
                    res?.type === "GET_ACTUAL_DAMAGE_RECEIPT_EMAIL_SUCCESS"
                ) {
                    downloadExcelFileData(res?.payload?.data);
                    setLines(res?.payload?.data);
                    setSelectedRows([]);
                }

            } catch (error) {
                notification.error({
                    message: "Error",
                    description: "Failed to refresh data.",
                });
            } finally {
                setLoading(false);
            }

        }).finally(() => {
            setEmailSending(false);
        });
    };



    const totalQuantity = () => {
        let sumQty = lines.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.quantity);
        }, 0);
        return sumQty;
    }

    const totalSum = () => {
        let sumAmount = lines.reduce(function (previousValue, currentValue) {
            return previousValue += Number(currentValue.net_amount);
        }, 0);
        return sumAmount;
    }

    return (
        <div className="styleContainer">
            <div className="styleBody h-100">
                <PageHeader title={"Actual Damage Receipt Email"} />
                <div className="bodyStyle">
                    <Collapse
                        style={{ width: "99%", margin: "10px" }}
                        bordered={false}
                        defaultActiveKey={['1']}
                        expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                    >
                        <Panel header="Filters" key="1" className="site-collapse-custom-panel" extra={<Button
                            onClick={() => {
                                history.push("/saleperson");
                            }}
                            className="iconBtn crudBTN"
                            shape="circle"
                        />}>
                            <Form
                                form={form}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                onFinish={onFinish}
                                autoComplete="off"
                            >
                                <Row>
                                    <Col xs={24} xl={8}>
                                        <Form.Item label="From Date" name="fromDate"
                                        >
                                            <DatePicker
                                                size="small"
                                                id="fromData"
                                                format="MM-DD-YYYY"
                                                allowClear
                                                className="dateInput customInputs"
                                                defaultValue={moment()}
                                                value={moment()}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={8}>
                                        <Form.Item label="To Date" name="toDate"
                                        >
                                            <DatePicker
                                                size="small"
                                                id="toDate"
                                                format="MM-DD-YYYY"
                                                allowClear
                                                className="dateInput customInputs"
                                                defaultValue={moment()}
                                                value={moment()}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={8}>
                                        <Form.Item
                                            name="customer"
                                            label="Customer"
                                            initialValue={"All"}
                                        >
                                            <Select
                                                size="small"
                                                autoComplete={"nope"}
                                                allowClear
                                                showSearch
                                                optionFilterProp="children"
                                                loading={saleOrderFormData.loading}
                                                onSearch={(value) => optimizedFn(value)}
                                            >
                                                <Option value={"All"}>All</Option>
                                                {saleOrderFormData?.payload?.customerDetail.map(
                                                    (item) => {
                                                        return (
                                                            <Select.Option
                                                                key={item.customer_id}
                                                                value={item.customer_id}
                                                            >
                                                                {" "}
                                                                {`${item.customer_code} - ${item.customer_name}`}
                                                            </Select.Option>
                                                        );
                                                    }
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col xs={24} xl={8}>
                                        <Form.Item
                                            label="Payment Term"
                                            name="term"
                                            initialValue={"All"}
                                        >
                                            <Select
                                                size="small"
                                                autoComplete={"nope"}
                                                filterOption={(input, option) => option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0}
                                                showSearch
                                                loading={paymentterm.loading}
                                            >
                                                <Option value={"All"}>All</Option>
                                                {paymentterm?.payload?.data.map(
                                                    (item) => {
                                                        return (
                                                            <Select.Option
                                                                key={item.term_id}
                                                                value={item.term_id}
                                                            >
                                                                {item.term_name}
                                                            </Select.Option>
                                                        );
                                                    }
                                                )}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} xl={8}>
                                        <div className="slc">
                                            <Form.Item
                                                name="cutomer_category"
                                                label="Customer Category"
                                                initialValue={"All"}
                                            >
                                                <Select
                                                    size='small'
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                    defaultValue={form.getFieldValue().cutomer_category}
                                                    className="styleInput w-100"
                                                >
                                                    <Option value={"All"}>All</Option>
                                                    {
                                                        customerTypes?.payload?.data.map((val) => {
                                                            return (
                                                                <Option value={val.customer_type_id}>{val.customer_type_name}</Option>
                                                            )
                                                        })
                                                    }
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </Col>
                                </Row>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button type="primary" htmlType="submit">
                                        Search
                                    </Button>
                                </div>
                                {
                                    selectedRows.length > 0 ? (
                                        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                                            <Button
                                                loading={emailSending}
                                                type="primary"
                                                onClick={sendEmail}
                                            >
                                                Send Email ({selectedRows.length})
                                            </Button>
                                        </div>
                                    ) : null
                                }
                            </Form>
                        </Panel>
                    </Collapse>
                    <div className="mainProductContainer">
                        <div style={{ padding: 10 }}>
                            {
                                loading ? (
                                    <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
                                        <Spin size='large' />
                                    </div>
                                ) : (
                                    lines.length > 0 ? (
                                        <Table
                                            title={() =>
                                                <CSVLink
                                                    filename={"damage-receipt-email.csv"}
                                                    data={excelData}
                                                    onClick={() => {
                                                    }}
                                                >
                                                    Download Excel
                                                </CSVLink>
                                            }
                                            rowSelection={{
                                                ...rowSelection,
                                            }}
                                            rowKey="damage_header_id"
                                            scroll={{
                                                x: 'max-content',
                                            }}
                                            perPage={100}
                                            columns={columns}
                                            dataSource={lines.length > 0 ? lines : []}
                                            loading={lines?.loading}
                                            paginate
                                            pagination={{
                                                defaultCurrent: 1,
                                                defaultPageSize: 100,
                                                pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000],
                                            }}
                                            summary={(pageData) => {
                                                let qty = pageData.reduce(function (
                                                    previousValue,
                                                    currentValue
                                                ) {
                                                    return (previousValue += parseFloat(
                                                        currentValue.quantity === "" ? 0 : currentValue.quantity
                                                    ));
                                                },
                                                    0);
                                                let amount = pageData.reduce(function (
                                                    previousValue,
                                                    currentValue
                                                ) {
                                                    return (previousValue += parseFloat(
                                                        currentValue.net_amount === "" ? 0 : currentValue.net_amount
                                                    ));
                                                },
                                                    0);
                                                return (
                                                    <>
                                                        <Table.Summary.Row>
                                                            <Table.Summary.Cell colSpan={2}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
                                                            </Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell></Table.Summary.Cell>
                                                            <Table.Summary.Cell><p style={{ textAlign: "right" }}> Total : </p>
                                                            </Table.Summary.Cell>
                                                            <Table.Summary.Cell>
                                                                <p style={{ textAlign: "right" }} className="totalquantity">
                                                                    {qty.toLocaleString("en-US")}
                                                                </p>
                                                            </Table.Summary.Cell>
                                                            <Table.Summary.Cell>
                                                                <p style={{ textAlign: "right" }} className="totalquantity">
                                                                    $ {amount.toLocaleString("en-US")}
                                                                </p>
                                                            </Table.Summary.Cell>
                                                        </Table.Summary.Row>
                                                        <Table.Summary.Row>
                                                            <Table.Summary.Cell colSpan={2} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(totalSum()).format("0,0.00")}
                                                            </Table.Summary.Cell>
                                                        </Table.Summary.Row>
                                                    </>
                                                );
                                            }}
                                        />
                                    ) : <div
                                        style={{
                                            backgroundColor: "#CCCCCC",
                                            borderWidth: "1pt",
                                            borderStyle: "Dashed",
                                            fontWeight: "bold",
                                            height: "25px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        No record(s)
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ActualDamageReceiptEmail;